module.exports = __webpack_public_path__ + "img/1.da733ecf.png";